// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// import your shared components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// import your pages
import Home from './pages/Home';
import MebershipsTesting from './pages/MebershipsTesting';

function App() {
  return (
    <>
      {/* This will show on every route */}
      <Navbar />

      {/* Your page content */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/test" element={<MebershipsTesting />} />
        <Route path="/about" element={<Navigate to="/#about" replace />} />
        <Route path="/facilities" element={<Navigate to="/#facilities" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {/* And this too */}
      <Footer />
    </>
  );
}

export default App;